export function isInteractionRequiredError(error) {
    if (error.name !== 'OAuthError') {
        return false;
    }
    const oauthError = error;
    return (oauthError.errorCode === 'interaction_required');
}



// WEBPACK FOOTER //
// webpack://OktaAuth/lib/oidc/util/errors.ts